"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_query_1 = require("react-query");
const koden_koden_crud_1 = require("@scott/koden.koden-crud");
const koden_koden_bin_icon_1 = require("@scott/koden.koden-bin-icon");
const koden_koden_inline_edit_text_1 = require("@scott/koden.koden-inline-edit-text");
const useStateMap_1 = __importDefault(require("../../hooks/useStateMap"));
const Container = styled_components_1.default.div `
	display: grid;
	align-items: center;
	grid-auto-flow: column;
	grid-gap: .5rem;
`;
const PanelListRow = ({ resource, columns, option, columnPlaceHolder, }) => {
    const recordId = option.id;
    const queryClient = (0, react_query_1.useQueryClient)();
    const [errorMap, setErrorMap] = (0, useStateMap_1.default)(columns);
    const updateRecordMutation = (0, koden_koden_crud_1.useUpdateRecordMutation)(resource);
    const removeMutation = (0, koden_koden_crud_1.useRemoveMutation)(resource);
    const onRemoteUpdate = (columnId, value, defaultValue) => {
        if (value !== defaultValue) {
            updateRecordMutation.mutate({ id: recordId.toString(), [columnId]: value }, {
                onSuccess(data) {
                    return __awaiter(this, void 0, void 0, function* () {
                        yield (0, koden_koden_crud_1.refreshList)(queryClient, resource, data);
                        setErrorMap((errorMap) => {
                            return Object.assign(Object.assign({}, errorMap), { [columnId]: "" });
                        });
                    });
                },
                onError(data) {
                    return __awaiter(this, void 0, void 0, function* () {
                        setErrorMap((errorMap) => {
                            return Object.assign(Object.assign({}, errorMap), { [columnId]: data.response.data.msg });
                        });
                    });
                },
            });
        }
    };
    return (React.createElement(Container, null,
        columns.map((column) => {
            const { id } = column;
            const key = `category_one_item_${resource}_${id}_${recordId}`;
            if (('type' in column) && column.type === 'ComponentType') {
                return React.createElement(React.Fragment, { key: key },
                    React.createElement(column.component, { id: id, record: option }));
            }
            else {
                const defaultValue = option[id];
                return (React.createElement(React.Fragment, { key: key },
                    React.createElement(koden_koden_inline_edit_text_1.KodenInlineEditText, { variant: "standard", id: `category_one_item_${resource}_${id}_${recordId}`, defaultValue: defaultValue, error: errorMap[id], onConfirm: (value) => {
                            onRemoteUpdate(id, value, defaultValue);
                        } }),
                    columnPlaceHolder && columnPlaceHolder(recordId)));
            }
        }),
        React.createElement(koden_koden_bin_icon_1.KodenBinIcon, { id: "bin-button", onClick: () => {
                if (window.confirm("確定要刪除嗎？")) {
                    removeMutation.mutate({ id: recordId.toString() }, {
                        onSuccess(data) {
                            return __awaiter(this, void 0, void 0, function* () {
                                yield (0, koden_koden_crud_1.refreshList)(queryClient, resource, data);
                            });
                        },
                    });
                }
            } })));
};
exports.default = PanelListRow;
//# sourceMappingURL=PanelListRow.js.map